import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import ItineraryPage from '../modules/apps/itinerary/ItineraryPage'
import TourdetailsPage from '../modules/apps/tourdetails/TourdetailsPage'
import ExcludePage from '../modules/apps/excludes/ExcludePage'
import LandingPage from '../modules/apps/landing/LandingPage'
import Departmentpage from '../modules/apps/management/department/Departmentpage'
import Organizationpage from '../modules/apps/management/organization/Organizationpage'
import DesignationPage from '../modules/apps/management/designation/DesignationPage'
import IslandPage from '../modules/apps/islandlanding/IslandPage'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))

  const Departmentpage = lazy(() => import('../modules/apps/management/department/Departmentpage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))

  const DesignationPage = lazy(
    () => import('../modules/apps/management/designation/DesignationPage')
  )

  const EmployeePage = lazy(() => import('../modules/apps/management/employee/EmployeePage'))

  const UserPage = lazy(() => import('../modules/apps/user/UserPage'))
  const LandingPage = lazy(() => import('../modules/apps/landing/LandingPage'))
  const Organizationpage = lazy(
    () => import('../modules/apps/management/organization/Organizationpage')
  )

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />

        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/management/employee/*'
          element={
            <SuspensedView>
              <EmployeePage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/management/designation/*'
          element={
            <SuspensedView>
              <DesignationPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/management/organization/*'
          element={
            <SuspensedView>
              <Organizationpage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/user/*'
          element={
            <SuspensedView>  
              <UserPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/itinerary/*'
          element={
            <SuspensedView>
              <ItineraryPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/tourdetail/*'
          element={
            <SuspensedView>
              <TourdetailsPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/exclude/*'
          element={
            <SuspensedView>
              <ExcludePage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/landing/*'
          element={
            <SuspensedView>
              <LandingPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/islandlanding/*'
          element={
            <SuspensedView>
              <IslandPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/management/department/*'
          element={
            <SuspensedView>
              <Departmentpage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/management/organization/*'
          element={
            <SuspensedView>
              <Organizationpage />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
